import { LoaderMessage } from "../../../components/loaderMessage/loaderMessage";
import PdfRender from "../../../components/pdfRender/pdfRender";
import { colors } from "../../../constants/colors";
import { useAttachmentUrls } from "../hooks/useAttachmentUrls";

interface PortalQuestionnaireAttachmentProps {
  mergedPdfToRender?: File | null;
}

const PortalQuestionnaireAttachment = (
  props: PortalQuestionnaireAttachmentProps,
) => {
  const { urls, isLoading } = useAttachmentUrls();

  if (isLoading) {
    return (
      <div className="flex h-full w-full items-center justify-center">
        <LoaderMessage message="Fetching attachment..." />
      </div>
    );
  }

  return (
    <div className="portal-questionnaire-attachment h-full w-full overflow-auto p-2">
      {props.mergedPdfToRender ? (
        <PdfRender
          file={props.mergedPdfToRender}
          backgroundColor={colors.primaryGray[16]}
          className="rounded-lg p-2"
        />
      ) : (
        <>
          {urls &&
            urls.length > 0 &&
            urls.map((url, index) => (
              <PdfRender
                key={index + url}
                file={url}
                backgroundColor={colors.primaryGray[16]}
                className="rounded-lg p-2"
              />
            ))}
        </>
      )}
    </div>
  );
};

export default PortalQuestionnaireAttachment;
